"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameFlowModule = void 0;
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var actions_1 = require("./actions");
exports.GameFlowModule = new inversify_1.ContainerModule(function (bind) {
    bind(interfaces_1.TypesFlow.boot).to(actions_1.BootAction);
    bind(interfaces_1.TypesFlow.LevelStart).to(actions_1.LevelStartAction);
    bind(interfaces_1.TypesFlow.LevelEnd).to(actions_1.LevelEndAction);
    bind(interfaces_1.TypesFlow.LevelNext).to(actions_1.LevelNextAction);
    bind(interfaces_1.TypesFlow.LevelRestart).to(actions_1.LevelRestartAction);
    bind(interfaces_1.TypesFlow.PlayWith).to(actions_1.PlayWithOpponentAction);
    if (process.env.NODE_ENV === "development") {
        bind("flow.cheats").to(actions_1.CheatsAction);
    }
});
//# sourceMappingURL=GameFlowModule.js.map